/**
 * Utility functions for formatting AI-generated content
 */

/**
 * Remove markdown asterisks from AI responses while preserving meaning
 * Converts **bold** to plain text, removes * bullet markers
 */
export function cleanAIContent(text) {
  if (!text) return text;
  
  // Remove double asterisks (bold markers)
  let cleaned = text.replace(/\*\*/g, '');
  
  // Remove single asterisks that are used for italic (but keep list markers)
  // Only remove asterisks that are wrapping text (have matching pairs)
  cleaned = cleaned.replace(/(?<!\n)\*([^*\n]+)\*/g, '$1');
  
  return cleaned;
}

/**
 * Format AI content for display - removes markdown formatting
 * and cleans up the text for professional presentation
 */
export function formatAIResponse(text) {
  if (!text) return text;
  
  let formatted = text;
  
  // Remove markdown bold markers
  formatted = formatted.replace(/\*\*/g, '');
  
  // Remove markdown italic markers (single asterisks wrapping text)
  formatted = formatted.replace(/\*([^*\n]+)\*/g, '$1');
  
  // Clean up excessive newlines
  formatted = formatted.replace(/\n{3,}/g, '\n\n');
  
  return formatted.trim();
}

export default { cleanAIContent, formatAIResponse };
